// i18n area 'vms' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.bg-BG.meta.json.
import type { enUS } from './vms'

export const bgBG: typeof enUS = {
  vms: {
    spof: {
      title: 'Независимост от възела',
      single: 'Единична точка на отказ',
      alternativesNow: 'Алтернативи сега',
      structural: 'По конструкция',
      binding: 'Обвързващо ограничение',
      movableNow: 'Миграцията е възможна сега',
    },
    title: 'Виртуални машини',
    migratingChip: 'Тече миграция',
    templateChip: 'Шаблон',
    expendableTooltip: 'В деградирал клъстер тя е сред първите, които се спират, и може да не се рестартира след загубата на възел.',
    expendableHaTooltip: 'Винаги се рестартира, докато клъстерът е здрав; в деградирал клъстер защитените ВМ са с предимство — тя може да бъде спряна или да остане изключена, докато клъстерът отново не стане цял, след което се връща сама.',
    viewDetails: 'Виж детайли',
    profileLegacy: 'Друга ОС',
    hugePagesNone: 'Няма — обикновена памет',
    hugePages2M: 'Страници по 2 MiB',
    hugePages1G: 'Страници по 1 GiB',
    searchPlaceholder: 'Търси по име',
    name: 'Име',

    // Terminologia UNA (#94a): la phase si chiama 'Fase' ovunque — la
    // vecchia chiave 'state' è morta col polish della lista.
    vcpus: 'vCPU',
    memory: 'Памет',
    ipAddresses: 'IP адреси',
    noIp: 'Няма IP',
    authorityNode: 'Отговорен възел',
    authorityNextStart: 'назначава се при следващия старт',
    scope: 'Скоуп',
    empty: 'Няма виртуални машини',
    loadError: 'Неуспешно зареждане на виртуалните машини — достъпен ли е бекендът на TVirt?',
    filterOverlay: 'оверлейна мрежа',
    filterDisk: 'диск',
    filterImage: 'образ',
    filteredBy: 'Филтрирани по {kind}',
    filterPhase: 'Фаза',
    filterProtection: 'Защита',
    filterAll: 'Всички',
    filterScopePlaceholder: 'Филтър по скоуп',
    filtersToggle: 'Филтри',
    scopeTree: {
      title: 'Скоупове',
      all: 'Целият клъстер',
      noChildren: 'Тук няма под-скоупове',
      recursive: 'Включи наследниците',
      collapse: 'Свий панела със скоупове',
      up: 'Едно ниво нагоре',
      countTooltip: '{direct} ВМ в този скоуп · {total} с наследниците'
    },

    // Il picker ISO a due passi (#85): prima il catalogo, poi le sue ISO.
    isoPicker: {
      catalog: 'Каталог',
      unknownCatalog: 'Извън видимите каталози',
      noIsos: 'В този каталог няма готови ISO образи'
    },
    actionsHeader: 'Действия',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Хардуер',
      tags: 'Тагове',
      age: 'Възраст',
      disk: 'диск',
      disks: 'диска',
      empty: 'Още няма шаблони — маркирайте изключена ВМ като шаблон или клонирайте ВМ като шаблон.',
      clone: 'Клонирай / разгърни',
      editTags: 'Редактирай таговете',

      // Round K3 (#64): esporta il template come file .tvtpl del catalogo.
      exportAction: 'Експортирай в каталога (.tvtpl)',
      exportTitle: 'Експорт в каталог',
      exportSubmit: 'Експортирай',
      exportError: 'Неуспешно експортиране',
      exportHint: 'Шаблонът се опакова в .tvtpl архив (хардуерен манифест + всеки диск, сплескан в qcow2) като нов файл „Шаблон ВМ“ в избрания каталог. NIC, CD/DVD носителите и cloud-init не пътуват — спецификацията на формата изброява всеки умишлен пропуск.',
      exportName: 'Име на файла',
      exportNameHint: 'Празно = <template>-export-<n>',
      exportStorageDefault: 'Хранилището за метаданни на шаблона',

      // Importa da catalogo (Luca 2026-08-03): l'ingresso in toolbar del tab
      // Template — il backend K3/K4 copre tutti i formati vm-template, la
      // scelta è il FILE (il formato viaggia in sola lettura).
      importAction: 'Импортирай от каталог',
      importTitle: 'Импорт от каталог',
      importHint: 'Готов файл „Шаблон ВМ“ от избрания каталог става шаблон в инвентара: форматът на файла (tvtpl, ova, ovf или гол qcow2) сам решава как се импортира — вие избирате само файла.',
      importFile: 'Файл от каталога',
      importFileHint: 'Импортират се само готови файлове — файл по средата на качване не може да се импортира',
      importNoFiles: 'В този каталог няма готови файлове „Шаблон ВМ“ — първо качете или експортирайте един'
    },
    templateDetail: {
      quickDeploy: 'Съвместимост с QuickDeploy',
      quickDeployNone: 'Не е декларирана',
      quickDeployHint: 'Декларирайте я само ако golden образът съдържа cloud-init (Linux) или cloudbase-init след sysprep /generalize (Windows): платформата се доверява на декларацията и никога не гледа вътре в госта.',
      notFound: 'Шаблонът не е намерен',
      frozen: 'Хардуерната конфигурация е замразена: превърнете шаблона обратно във ВМ, за да я промените. Името, бележките и таговете остават редактируеми.',
      storage: 'Хранилище',
      size: 'Размер',
      configTitle: 'Конфигурация (замразена)',
      usbClasses: 'Изисквани USB класове',
      gpuClasses: 'Изисквани GPU класове'
    },
    sharedDisksTab: {
      title: 'Споделени дискове',
      sharing: 'Споделяне',
      sharingNone: 'Едно закачане',
      sharingMultiwriter: 'Споделен запис (multiwriter)',
      sharingReadonly: 'Споделено само за четене',
      usedBy: 'Използва се от',
      attachedTo: 'Закачен към',
      notAttached: 'Не е закачен към никоя VM',
      changeSharing: 'Промяна на режима на споделяне',
      changeSharingTitle: 'Режим на споделяне',
      changeSharingLocked: 'Режимът се променя само докато никоя VM не използва диска',
      sharingChanged: 'Режимът на споделяне е обновен.',
      lun: 'Цял LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Сериен номер',
      antiAffinityWarning: 'Два или повече члена работят на един и същ възел без правило за анти-афинитет: отказ на един възел ги сваля всички',
      antiAffinityCreate: 'Създай правилото',
      createSourceLun: 'Приеми цял LUN от target-а',
      createLunNumber: 'Номер на LUN (namespace id при NVMe)',
      createLunHint: 'Нищо не се заделя: размерът се отчита от устройството при приемането',
      noPr: 'В тази версия няма SCSI-3 persistent reservations: Windows Failover Cluster с класически споделен диск не е валидиран; клъстерите, които се координират по мрежата (GFS2/OCFS2, RHEL HA, shared-disk бази данни), да'
    },
    unusedDisksTab: {
      title: 'Неизползвани дискове',
      attach: 'Прикачи към ВМ',
      attachTitle: 'Прикачване към ВМ',
      vm: 'Виртуална машина',
      noVms: 'Няма налични ВМ',
      noSlots: 'Няма свободни слотове на тази ВМ',

      // Crea disco standalone (#87): tornato dall'Inventario pensionato, ora
      // con campo scope ESPLICITO (non c'è una VM da cui ereditare).
      create: 'Създай диск',
      createTitle: 'Създаване на диск',
      createSourceBlank: 'Празен диск',
      createSourceImage: 'От образ в каталога',
      createImage: 'Образ',
      createImageEmpty: 'Няма готов образ на VM шаблон във видимите каталози',
      createSizeFromImageHint: 'Предварително попълнено с виртуалния размер на образа — може само да расте',

      // #107 (DISTRUTTIVO, ratificato): qcow2 → catalog file vm-template
      // sullo stesso storage, zero byte copiati — il disco cessa di esistere.
      convert: 'Преобразувай в шаблон на ВМ…',
      convertOnlyQcow2: 'Преобразуват се само qcow2 дискове — raw не е регистрируем шаблонен формат',
      convertTitle: 'Преобразуване в шаблон на ВМ',
      convertSubmit: 'Преобразувай (унищожава диска)',
      convertError: 'Неуспешно стартиране на преобразуването',
      convertWarning: 'РАЗРУШИТЕЛНО: дискът става файл „Шаблон ВМ“ в избрания каталог — същото хранилище, нула копирани байта — и ПРЕСТАВА ДА СЪЩЕСТВУВА като диск. Няма връщане назад освен създаването на нов диск от шаблона.',
      convertNameHint: 'Името на файла в каталога — по подразбиране това на диска',
      convertConfirm: 'Разбирам: дискът ще бъде унищожен',
      convertStarted: 'Преобразуването е стартирано — шаблонът се появява в каталога, когато задачата завърши.',
      storageLockHint: 'Хранилището се сменя само с действието „Премести“',
      source: 'Произход',
      sourceClone: 'Клон на друг диск',
      sourceCloneLinked: 'Свързан клон на друг диск',
      sourceImage: 'Създаден от образ',
      sourceBlank: 'Създаден празен',
      allocated: 'Заделено / виртуален размер',
      observedAt: 'Наблюдаван на',
      snapshots: 'Снапшоти',
      snapshotsEmpty: 'Няма снапшоти'
    },
    phase: {
      defined: 'Никога не е включвана',
      starting: 'Стартира се',
      running: 'В изпълнение',
      stopping: 'Спира се',
      stopped: 'Изключена',
      paused: 'На пауза',
      failed: 'В грешка',
      deleting: 'Изтрива се'
    },
    stopCause: {
      'api': 'Спряна от TVirt (действие или API)',
      'guest-shutdown': 'Изключване, започнато от операционната система на госта',
      'crash': 'Срив на госта',
      'qemu-exit': 'Процесът QEMU завърши неочаквано',
      'host-reboot': 'Възелът беше рестартиран',
      'migrated': 'Мигрирана на друг възел',
      'fenced': 'Прекратена от HA фенсинга (възелът се завърна)'
    },
    detail: {
      notFound: 'Виртуалната машина не е намерена',
      details: 'Детайли',
      id: 'ID',
      scope: 'Скоуп',
      profile: 'Хардуерен профил',
      firmware: 'Фърмуер',
      firmwareFile: 'Версия на UEFI фърмуера',
      firmwareUpdate: 'Налично обновление',
      firmwareUpdateHint: 'Платформата доставя по-нов UEFI фърмуер. Обновлението никога не е автоматично: прилага се при изключена ВМ, когато вие решите.',
      arch: 'Архитектура',
      node: 'Възел',
      bootOrder: 'Ред на зареждане',
      agent: 'Състояние на агента',
      agentConnected: 'Свързан',
      agentNotConnected: 'Не е свързан',
      protected: 'Защитена',
      linkedClones: 'Свързани клонове',
      restartPolicy: 'Политика на рестартиране',
      preferredNode: 'Предпочитан възел',
      noPreference: 'Без предпочитание (автоматично разполагане)',
      preferNodes: 'Предпочитани тагове на възел',
      requireNodes: 'Задължителни тагове на възел',
      noPlacementTags: 'Няма',
      placementTag: 'Таг',
      placementValue: 'Стойност',
      placementAddTag: 'Добави таг',
      proximityHa: 'HA на TVirt Proximity',
      proximityHaRestarts: 'HA рестарта',
      proximityHaGaveUp: 'цикъл от сривове — HA се отказа',
      failoverProtection: 'Защита в деградирал клъстер',
      protectionProtected: 'Защитена',
      protectionExpendable: 'Може да се пожертва при деградация',
      protectionInherit: 'Наследява',
      lastStop: 'Последно спиране',
      yes: 'Да',
      no: 'Не',
      tabOverview: 'Преглед',
      tabSnapshots: 'Снапшоти',
      tabBackups: 'Копия',
      hardware: 'Хардуер',
      name: 'Име',
      hwSystem: 'Система',
      hwCpu: 'CPU',
      hwMemory: 'Памет',
      hwBoot: 'Стартиране',
      hwIdentity: 'Идентичност',
      hwCluster: 'Клъстер и агент',
      cpuTopology: 'Топология на CPU',
      cpuModel: 'Модел на CPU',
      cpuLimit: 'Лимит на CPU',
      cpuWeight: 'Тегло на CPU',
      cpuNested: "Вложена виртуализация",
      cpuNestedHint: "Излага vmx/svm на госта (само с CPU модел host). При работеща ВМ промяната важи от следващия power cycle (PendingRestart); разполагането допуска само възли с включен nested.",
      unlimited: 'Без ограничение',
      memory: 'Памет',
      balloon: 'Балон',
      hugePages: 'Огромни страници',
      hugePagesTradeoff: 'По-малко работа по транслация на адресите и памет, която никога не стига до диска; в замяна резервацията остава заключена на възела, докато ВМ е включена, паметта вече не се дедуплицира и стартът се проваля, ако възелът няма достатъчно свободни страници.',
      disks: 'Дискове',
      cdroms: 'CD/DVD устройства',
      nics: 'Мрежови интерфейси',
      slot: 'Слот',
      disk: 'Диск',
      encrypted: 'Шифрован',
      image: 'Образ',
      emptyDrive: 'Празно устройство',
      emptyOption: '(празно)',
      network: 'Мрежа',
      mac: 'MAC',
      connected: 'Свързан',
      unplugged: 'Разкачен',
      noDevices: 'Няма',
      screenshot: 'Снимка на екрана',
      capturedAt: 'Заснета в',
      noCapture: 'Няма заснемане',
      snapshotName: 'Име',
      snapshotCreated: 'Създаден',
      snapshotMemory: 'Включена памет',
      noSnapshots: 'Няма снапшоти',
      pendingRestart: 'Чакащи промени: ще се приложат при следващия цикъл на захранване.',
      applied: 'приложено',
      appliedHint: 'ВМ работи с тази стойност — конфигурираната се прилага при следващия цикъл на захранване.',
      actionError: 'Неуспешно действие',
      actionStillRunning: 'Действието още тече — резултатът му още не е известен',
      tabConsole: 'Конзола',
      consoleConnect: 'Свържи се',
      consoleDisconnect: 'Прекъсни връзката',
      consoleConnecting: 'Свързване…',
      consoleReconnecting: 'Свързване…',
      consoleUnavailable: 'Конзолата е достъпна, докато ВМ е в изпълнение или на пауза.',
      consoleError: 'Неуспешно свързване с конзолата',
      consoleTaken: 'Сесията на конзолата беше поета от {user}',
      consoleReconnect: 'Свържи се отново',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Задръж {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Отвори на цял екран в нов раздел',
      consoleLoadFailed: 'ВМ не е намерена или правата са недостатъчни',
      consoleClose: 'Затвори',
      tabStats: 'Статистика',
      tabTasks: 'Задачи',
      tabLogs: 'Логове',
      statsCpu: 'CPU',
      statsMemory: 'Памет',
      statsDisk: 'I/O на диска',
      statsRange: 'Интервал',
      statsNoData: 'Няма данни в интервала — статистиката се снема, докато ВМ е в изпълнение.',
      statsError: 'Неуспешно зареждане на статистиката',
      cpuUsage: 'Използване',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Използвана',
      memGuestAvailable: 'Налична (гост)',
      schema: 'Схема',
      consoleProtocol: 'Конзола',
      agentEnabled: 'Гост агент',
      metadataStorage: 'Хранилище за метаданни',
      startupOnBoot: 'Стартиране при зареждане',
      startupOrder: 'Ред на стартиране',
      startupDelay: 'Забавяне на стартирането',
      seconds: 'с',
      enabled: 'Включено',
      disabled: 'Изключено'
    },
    actionsAvailable: 'Налични действия',
    actions: {
      start: 'Стартирай',
      stop: 'Спри',
      pause: 'Пауза',
      resume: 'Възобнови',
      reset: 'Нулирай',
      migrate: 'Мигрирай',
      clone: 'Клонирай',
      moveStorage: 'Премести в хранилище…',
      moveScope: 'Премести в скоуп…',
      openConsole: 'Отвори конзолата',
      forceStop: 'Принудително изключване',
      markTemplate: 'Маркирай като шаблон',
      unmarkTemplate: 'Превърни обратно във ВМ',
      error: 'Неуспешно изпълнение на действието'
    },
    cordon: {
      confirmTitle: 'Възелът е в поддръжка',
      confirmHint:
        'Кордонът не може да бъде свален, докато хранилището на клъстера е недостъпно. С потвърждението заявявате, че знаете: ВМ се включва там въпреки това, а съгласието остава записано в задачата.',
      confirm: 'Включи въпреки това'
    },
    markTemplate: {
      confirmTitle: 'Да се маркира ли {name} като шаблон?',
      confirmBody: 'Конфигурацията се замразява и ВМ вече не може да се включва — само да се клонира или да стане отново ВМ. Името, бележките и таговете остават редактируеми.',
      confirm: 'Маркирай като шаблон',
      moved: '{name} вече е шаблон — премести се в раздела „Шаблони“.'
    },
    unmarkTemplate: {
      confirmTitle: 'Да се превърне ли {name} обратно във ВМ?',
      confirmBody: 'Шаблонът отново става обикновена ВМ: редактируема и стартируема (следващият старт я разполага на възел).',
      confirm: 'Превърни обратно във ВМ',
      moved: '{name} отново е виртуална машина — премести се в раздела „Виртуални машини“.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'По таг на възел',
      hint: 'таг=стойност, разделени със запетая (в логическо И): изборът се прави измежду съответстващите възли',
      invalid: 'Невалиден формат — използвайте таг=стойност, разделени със запетая',
      resolved: 'Съответстващи членове: {nodes}'
    },
    migrate: {
      title: 'Жива миграция',
      submit: 'Мигрирай',
      target: 'Целеви възел',
      auto: 'Автоматично (Proximity)',
      hint: 'ВМ се мести без цикъл на захранване. Всяко хранилище, което докосва, трябва да е споделено; ВМ на пауза мигрира на пауза.',
      error: 'Миграцията беше отказана'
    },
    moveStorage: {
      title: 'Преместване в хранилище',
      submit: 'Премести',
      target: 'Целево хранилище',
      noTargets: 'Никое хранилище не приема дискове',
      hint: 'Всички дискове на изключената ВМ пътуват към избраното хранилище един по един, запазвайки своя id — вече намиращите се там се пропускат. Напредъкът живее в страницата със задачите.',
      error: 'Преместването беше отказано'
    },
    moveScope: {
      title: 'Преместване в скоуп',
      submit: 'Премести',
      target: 'Целеви скоуп',
      hint: 'ВМ сменя скоупа незабавно — id и дисковете остават, собствените ѝ дискове я следват и тя може да остане включена. Днес живее в {scope}. Кой я вижда се променя със скоупа.',
      error: 'Преместването в скоуп беше отказано'
    },
    start: {
      title: 'Стартиране на ВМ',
      submit: 'Стартирай',
      target: 'Целеви възел',
      auto: 'Автоматично (препоръчително)',
      recommended: 'препоръчително',
      hint: 'Изберете целеви възел или оставете Proximity да реши измежду валидните кандидати. Възлите, които не могат да я приемат, са деактивирани с посочена причина.',
      error: 'Неуспешно стартиране на ВМ'
    },
    console: {
      media: 'CD/DVD устройства',
      mediaGuestToolsHint: 'Съдържа TVirt Guest Tools — оттук можете да ги извадите или да премахнете устройството',
      slotOpsDeferred: 'При този профил добавянето и премахването на устройства се прилагат при следващия цикъл на захранване (смените на носителя са незабавни).',
      mountGuestTools: 'Монтирай TVirt Guest Tools',
      ejectGuestTools: 'Извади TVirt Guest Tools',
      bootOrder: 'Ред на зареждане',
      bootOrderHint: 'Новият ред се запазва веднага и се прилага при следващия цикъл на захранване — сесията на конзолата остава свързана.'
    },
    snapshots: {
      create: 'Създай снапшот',
      createTitle: 'Създаване на снапшот',
      createSubmit: 'Създай',
      name: 'Име',
      nameHint: 'Букви, цифри, точка, тире, долна черта.',
      consistencyHint: 'Консистентността е автоматична: гост агентът замразява файловите системи, когато отговаря; иначе ВМ отива за миг на пауза около снапшота.',
      memory: 'Включи паметта',
      memoryHint: 'Заснема живата RAM: възстановяването възобновява ВМ в изпълнение. Изисква всички дискове да са qcow2.',
      currentChip: 'Вие сте тук',
      revert: 'Възстанови',
      revertTitle: 'Да се възстанови ли {name}?',
      revertBody: 'Дисковете се връщат към състоянието на снапшота; всичко, случило се след него, се губи. Снапшот само на дисковете изисква спряна ВМ.',
      delete: 'Изтрий',
      deleteTitle: 'Да се изтрие ли снапшотът {name}?',
      deleteBody: 'Точката за възстановяване изчезва; съдържанието на дисковете остава непокътнато.',
      deleteMergeHint: 'Неговата делта се слива в {children}: всяка по-късна точка за възстановяване остава валидна.',
      deleteDuplication: 'Приемам дублирането',
      deleteDuplicationHint: 'Делтата се копира във всеки от {count} четци (дъщерните snapshot-и и, ако този е текущият, активната глава): заетото място може да расте вместо да намалява.',
      error: 'Операцията със снапшота беше отказана'
    },
    clone: {
      title: 'Клониране на ВМ',
      submit: 'Клонирай',
      name: 'Име на копието',
      storage: 'Целево хранилище за дисковете',
      sameStorage: 'Същото като на източника',
      full: 'Пълно копие',
      fullHint: 'Копира всеки байт и прекъсва връзката с изходните дискове. По подразбиране се прави свързан клон: мигновен, но окован към източника (само qcow2).',
      hint: 'Клонът запазва конфигурацията и фърмуера на източника; MAC адресите и TPM идентичността са нови.',
      markAs: 'Тип на клона',
      markAsInheritVm: 'Като източника (ВМ)',
      markAsInheritTemplate: 'Като източника (шаблон)',
      markAsVm: 'Виртуална машина',
      markAsTemplate: 'Шаблон',
      markAsHintVm: 'Изберете „Шаблон“, за да повишите копието с една стъпка.',
      markAsHintTemplate: 'Изберете „Виртуална машина“, за да разгърнете от този шаблон с една стъпка.',
      error: 'Клонирането беше отказано'
    },
    bulk: {
      selected: 'избрани',
      deleteTitle: {
        one: 'Да се изтрие ли {count} избрана ВМ?',
        other: 'Да се изтрият ли {count} избрани ВМ?'
      },
      deleteBody: 'Всяка ВМ минава през същите проверки като единичното изтриване; отказите се докладват по елемент.',
      done: 'приети',
      refused: 'отказани'
    },
    delete: {
      button: 'Изтрий',
      confirmTitle: 'Да се изтрие ли {name}?',
      confirmBody: 'Виртуалната машина и притежаваните от нея дискове ще бъдат изтрити. Операцията е необратима.',
      keepDisks: 'Запази дисковете',
      keepDisksHint: 'Дисковете, създадени с ВМ, остават в своето хранилище като самостоятелни дискове.',
      confirm: 'Изтрий',
      cancel: 'Отказ',
      error: 'Неуспешно изтриване',
      blockedPhase: 'Първо спрете ВМ',
      blockedProtected: 'ВМ е защитена — първо премахнете защитата',
      blockedDeleting: 'Изтриването вече тече'
    },
    logs: {
      title: 'Логове',
      subtitle: 'Структурирани лог кадри от задачите, които засягат тази ВМ',
      when: 'Кога',
      task: 'Задача',
      level: 'Ниво',
      message: 'Съобщение',
      empty: 'Още няма логове',
      loadError: 'Неуспешно зареждане на логовете — достъпен ли е бекендът на TVirt?'
    },
    stop: {
      title: 'Спиране на виртуална машина',
      modeGraceful: 'Плавно изключване',
      modeGracefulHint: 'От операционната система на госта се иска да се изключи по естествен начин (ACPI); ако тя пренебрегне заявката, след таймаута се задейства принудителното изключване.',
      modeForced: 'Принудително изключване',
      modeForcedHint: 'Спира захранването незабавно — като издърпване на щепсела.',
      timeout: 'Таймаут преди резервния вариант (секунди)',
      timeoutHint: 'Колко време да се изчака гостът, преди да се форсира изключването'
    },

    // Il menu del bottone split di creazione (Luca 2026-07-23): "Da zero" apre
    // il wizard, le altre due voci sono stub di roadmap.
    createFromScratch: 'От нулата',
    createFromTemplate: 'От шаблон',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Изпълни deploy',
      error: 'Deploy неуспешен',
      compatNote: 'QuickDeploy изисква съвместим с QuickDeploy темплейт: платформата персонализира госта (мрежа, домейн, активиране) при първото стартиране.',
      template: 'Темплейт',
      noTemplates: 'Нито един темплейт не декларира съвместимост с QuickDeploy — декларирайте я от таба Темплейти (Linux с cloud-init, Windows с cloudbase-init след sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Име на хост',
      hostnameHint: 'Име на хост или FQDN; празно = името на VM (Windows: най-много 15 знака)',
      ip: 'IP адрес',
      ipHint: 'Хост и префикс, напр. 192.168.122.101/24; празно = DHCP',
      gateway: 'Gateway',
      dns: 'DNS сървъри',
      dnsHint: 'До три, разделени със запетая',
      count: 'Инстанции',
      countHint: 'Повече от една: наричат се <име>-1…-N, само DHCP',
      user: 'Потребител',
      userHint: 'Празно = потребителят по подразбиране на образа (Linux) или Administrator (Windows)',
      password: 'Парола',
      passwordHint: 'Записва се в генерираната user-data, която платформата после декларира като тайна: никой не я чете обратно',
      sshKeys: 'Публични SSH ключове',
      sshKeysHint: 'По един на ред (ssh-ed25519 AAAA… коментар)',
      productKey: 'Product key за Windows',
      kmsServer: 'KMS сървър',
      kmsHint: 'Хост или хост:порт — изисква product key (KMS клиентски ключ)',
      adDomain: 'Присъединяване към домейн Active Directory',
      adDomainHint: 'Празно = без присъединяване към домейн',
      adUser: 'Акаунт за присъединяване',
      adPassword: 'Парола на акаунта за присъединяване',
      adOu: 'Целева OU (по избор)',
      advanced: 'Разширени: сурови документи',
      userData: 'user-data (сурова)',
      userDataHint: 'Замества генерираната user-data: потребителят, паролата, ключовете и полетата за Windows по-горе трябва да останат празни',
      networkConfig: 'network-config (сурова)',
      networkConfigHint: 'Замества генерираната мрежа: IP, gateway и DNS по-горе трябва да останат празни',
      secret: 'Третирай суровата user-data като тайна',
      secretHint: 'Маркирана като тайна, тя спира да се връща от API на когото и да е и пътува в Checkpoint запечатана с masterpass',
      startNow: 'Стартирай веднага',
      startNowHint: 'Всяка инстанция стартира щом бъде дефинирана; seed-ът се създава при това стартиране'
    },

    create: {
      nicAttachmentNetwork: 'Логическа мрежа (fabric)',
      nicNetwork: 'Логическа мрежа',
      nicNetworkHint: 'ПРЕПОРЪЧИТЕЛНИЯТ път (F3): vNIC се реализира на ПРОИЗВОДНИЯ bridge на обслужващия възел — bridge се ражда при явния apply на fabric, а стартиране на възел, който още не го носи, отказва говорейки. Когато си отиде последната референция на флота, bridge изпада при следващия apply.',
      button: 'Създай ВМ',
      title: 'Създаване на виртуална машина',
      dialogTitle: 'Създаване на виртуална машина',
      stepGeneral: 'Общи',
      stepGeneralHint: 'Име и профил',
      stepCompute: 'CPU и RAM',
      stepComputeHint: 'Топология и размери',
      stepDisks: 'Дискове',
      stepDisksHint: 'Създай или прикачи',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Устройства и носители',
      stepNetwork: 'Мрежа',
      stepNetworkHint: 'NIC: транк или бридж',
      stepSummary: 'Обобщение',
      stepSummaryHint: 'Провери и създай',
      name: 'Име',
      nameHint: 'Малки букви, цифри и тирета (DNS-1123)',
      nextButton: 'Напред',
      prevButton: 'Назад',
      submitButton: 'Създай',
      creating: 'Създаване…',
      sockets: 'Сокети',
      cores: 'Ядра на сокет',
      threads: 'Нишки на ядро',
      totalVcpus: 'Общо vCPU',
      memoryGib: 'Памет (GiB)',
      cpuModelHint: "'host' излага CPU на хоста",
      cpuLimitHint: 'Таван в ядра на хоста — празно = без ограничение',
      cpuNestedHint: "Излага vmx/svm на госта, за да може да изпълнява собствен хипервайзор — изисква CPU модел host и възел с включен nested",
      newDisk: 'Нов диск',
      attachDisk: 'Прикачи съществуващ диск',
      diskStorage: 'Хранилище',
      diskSize: 'Размер (GiB)',
      diskSelect: 'Диск',
      addDisk: 'Добави диск',
      addCdrom: 'Добави CD/DVD устройство',
      addNic: 'Добави мрежов интерфейс',
      remove: 'Премахни',
      slotLimit: 'Достигнат е лимитът на слотовете',
      cdromImage: 'Образ (празно устройство, ако липсва)',
      nicAttachment: 'Свързване',
      nicAttachmentTrunk: 'Оверлеен транк',
      nicAttachmentBridge: 'Бридж на хоста',
      nicUntagged: 'Нетагован оверлей',
      nicUntaggedNone: 'Няма (само таговани)',
      nicTrunkHint: 'Поне една страна: нетагован оверлей и/или съответствия на таговани VLAN — ВМ може да работи само на хостове, декларирани от всеки посочен оверлей',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Оверлейна мрежа',
      addTagged: 'Добави тагован VLAN',
      nicBridge: 'Име на бриджа на хоста',
      nicBridgeHint: 'NM бридж по име — ВМ може да работи само на сървъри, чиято хост мрежа декларира този бридж',
      nicMac: 'MAC (автоматично, ако е празно)',
      noDisksHint: 'Няма дискове: ВМ ще има само CD/DVD устройствата, които добавите.',
      noCdromsHint: 'Няма CD/DVD устройства: добавете едно, за да заредите от ISO образ.',
      mountGuestTools: 'Монтирай TVirt Guest Tools при първото стартиране',
      mountGuestToolsHint: 'Поставя ISO образа с virtio драйверите и гост агента в празно CD устройство (добавя се при нужда) — инсталаторът на Windows има нужда от тях, за да види дисковете.',
      noNicsHint: 'Няма мрежови интерфейси: ВМ ще стартира без свързаност.',
      taggedMappings: 'Съответствия на таговани VLAN',
      summaryDevices: 'Устройства',
      bootOrderTitle: 'Ред на зареждане',
      bootOrderHint: 'Влачете, за да пренаредите — печели първото зареждащо се устройство; NIC зареждат по PXE',
      bootOrderUp: 'Премести нагоре',
      bootOrderDown: 'Премести надолу',
      createError: 'Неуспешно създаване'
    },
    edit: {
      button: 'Редактирай',
      title: 'Редактиране на виртуална машина',
      cancel: 'Отказ',
      save: 'Запази',
      error: 'Неуспешно редактиране',
      modelStoppedOnly: 'Променя се само при изключена ВМ',
      firmwareStoppedOnly: 'Фърмуерът се променя само при изключена ВМ — при следващия старт машината тръгва с новия фърмуер, а UEFI променливите се запазват',
      hugePagesStoppedOnly: 'Променя се само при изключена ВМ — при следващия старт паметта се ражда върху новата основа',
      runningHint: 'Промените се прилагат при следващия цикъл на захранване',
      sectionCpu: 'CPU',
      sectionMemory: 'Памет',
      sectionPolicy: 'Политики'
    },
    devices: {
      networkChip: 'мрежа fabric',
      title: 'Устройства',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Добави USB устройство',
      addUsbTitle: 'Изискване на клас USB устройства',
      usbClassHint:
        'ВМ иска КЛАС USB устройства (стойност на таг usb-device), никога конкретно устройство: при старта конкретното свободно устройство се избира и резервира на възела. Тагвайте регистрираните устройства в „Клъстер › USB и PCIe ресурси“.',
      usbTag: 'Таг (usb-device)',
      usbValue: 'Стойност на класа',
      noUsbTags: 'Няма таг usb-device — създайте един и тагвайте регистрираните устройства в „Клъстер › USB и PCIe ресурси“.',
      noUsbValues: 'Този таг още няма декларирани стойности.',
      usbEmpty: 'Няма USB изисквания — добавете клас, за да прехвърлите устройство при старта.',
      usbClassChip: 'клас',
      usbPortChip: 'порт',
      usbUnclaimed: 'Никое устройство не е резервирано — решава се при старта на ВМ.',
      addGpu: 'Добави GPU',
      addGpuTitle: 'Изискване на клас GPU',
      gpuClassHint:
        'ВМ иска КЛАС GPU (стойност на таг gpu-device), никога конкретна карта: при старта конкретната свободна карта се избира и резервира на възела и ЗАЕДНО с нея се прехвърля цялата ѝ IOMMU група. Тагвайте регистрираните GPU в „Клъстер › USB и PCIe ресурси“.',
      gpuTag: 'Таг (gpu-device)',
      gpuValue: 'Стойност на класа',
      noGpuTags: 'Няма таг gpu-device — създайте един и тагвайте регистрираните GPU в „Клъстер › USB и PCIe ресурси“.',
      noGpuValues: 'Този таг още няма декларирани стойности.',
      gpuEmpty: 'Няма GPU изисквания — добавете клас, за да прехвърлите карта при старта.',
      gpuClassChip: 'клас',
      gpuGroupChip: 'IOMMU група ×',
      gpuUnclaimed: 'Никоя карта не е резервирана — решава се при старта на ВМ.',
      gpuPowerCycle: 'Няма горещо включване на GPU — промените важат от следващия цикъл на захранване (PendingRestart)',
      actions: 'Действия',
      attachDisk: 'Добави диск',
      attachDiskTitle: 'Добавяне на диск',
      attach: 'Прикачи',
      noFreeDisks: 'Няма неизползвани дискове — създайте един в „Виртуални машини › Неизползвани дискове“.',
      addCdrom: 'Добави устройство',
      addCdromTitle: 'Добавяне на CD/DVD устройство',
      editCdromTitle: 'Смяна на CD/DVD образ',
      changeMedia: 'Смени CD/DVD образа',
      ejectMedium: 'Извади',
      mountGuestTools: 'Монтирай TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools са монтирани',
      guestToolsClickMount: 'Поставя ISO образа TVirt Guest Tools в първото празно CD/DVD устройство',
      guestToolsClickUnmount: 'Кликнете, за да извадите — устройството остава, празно',
      guestToolsNoSlot: 'Няма празно CD/DVD устройство — добавете устройство (или извадете носител), за да монтирате TVirt Guest Tools',
      guestToolsSkew: 'Монтирана v{pinned}; възел {node} вече предоставя v{current}: извадете и монтирайте отново, за да обновите',
      ejectGuestTools: 'Извади TVirt Guest Tools (устройството остава, празно)',
      guestToolsEjectConfirmTitle: 'Да се извадят ли TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Носителят се изважда от включената ВМ — CD/DVD устройството остава, празно.',
      applyLive: 'Приложи веднага (ВМ е включена)',
      addNic: 'Добави интерфейс',
      addNicTitle: 'Добавяне на мрежов интерфейс',
      editNicTitle: 'Редактиране на мрежов интерфейс',
      bridgeChip: 'бридж',
      cable: 'Виртуален кабел',
      plug: 'Свържи виртуалния кабел',
      unplug: 'Разкачи виртуалния кабел',
      remove: 'Премахни',
      removeTitle: 'Да се премахне ли {device}?',
      removeBody: 'При включена ВМ промяната се прилага при следващия цикъл на захранване. Дисковете и образите се разкачат, никога не се изтриват.'
    }
  }
}
